'use client';

import { useStyle } from '@/classify';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { alpha, styled } from '@mui/material/styles';
import { ChevronDown as ArrowDown } from 'react-feather';
import Icon from '../../../Icon';
import defaultClasses from './categoryFaqItem.module.css';

const StyleAccordion = styled(Accordion)(({ theme }) => ({
  // width: 300,
  // color: theme.palette.success.main,
  boxShadow: 'none',
  '& .MuiSlider-thumb': {
    '&:hover, &.Mui-focusVisible': {
      boxShadow: `0px 0px 0px 8px ${alpha(theme.palette.success.main, 0.16)}`,
    },
    '&.Mui-active': {
      boxShadow: `0px 0px 0px 14px ${alpha(theme.palette.success.main, 0.16)}`,
    },
  },
  ':before': {
    backgroundColor: 'transparent',
  },
  '&.Mui-expanded': {
    margin: '0',
    padding: '0',
  },
  '.MuiButtonBase-root': {
    '&.MuiAccordionSummary-gutters': {
      padding: '0',
    },
  },
  '.MuiAccordionDetails-root': {
    padding: '0 0 8px',
  },
  borderBottom: `1px solid #ccc`,
}));

const StyleMuiAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  // backgroundColor: alpha(
  //     theme.palette.success.main,
  //     theme.palette.action.hoverOpacity
  // ),
  // color: theme.palette.success.contrastText,
  '&.MuiAccordionSummary-root.Mui-expanded': {
    minHeight: 'none',
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    color: 'pink',
    minHeight: 24,
  },
  '& .MuiAccordionSummary-content': {
    '&.Mui-expanded': {
      margin: '12px 0',
    },
  },
}));

const CategoryFaqItem = props => {
  const { question, answer } = props || {};

  const toHTML = str => ({
    __html: str,
  });

  const classes = useStyle(defaultClasses, props.classes);

  return (
    <StyleAccordion
      className={classes.root_accordion}
      // ref={refs.current[id]}
    >
      <StyleMuiAccordionSummary
        expandIcon={
          <Icon
            src={ArrowDown}
            size={24}
            className={classes.icon}
          />
        }
        sx={{}}
        className={classes.AccordionSummary}
      >
        <Typography
          dangerouslySetInnerHTML={toHTML(question)}
          className={[classes.typography, classes.bold].join(' ')}
        />
      </StyleMuiAccordionSummary>
      <AccordionDetails className={classes.AccordionDetails}>
        <Typography dangerouslySetInnerHTML={toHTML(answer)} />
      </AccordionDetails>
    </StyleAccordion>
  );
};

export default CategoryFaqItem;
